module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.a6c01d61.jpg";